<template>
  <div class="auth">
    <div class="error" v-show="isError">Error fetching token, please try again</div>
  </div>
</template>

<script>
  export default {
    name: 'auth',
    data () {
      return {
        isError: false
      }
    },

    mounted () {
      this.$store
        .dispatch('auth/loginFromCode', {code: this.$route.query.code})
        .then(() => {
          this.$store.dispatch('destiny/load')
          this.$router.push({name: 'home'})
        })
        .catch(() => {
          this.isError = true
        })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .auth {
    text-align: center;
    .error {
      font-size: 2rem;
      padding: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// Auth.vue?678a266e